export default __webpack_public_path__ + "static/image-4-mob-946ce9004232d139635799f6972f4f2d.jpg";